import { initializeApp } from "firebase/app"
import { initializeAnalytics } from "firebase/analytics"
import { getFirestore } from "firebase/firestore"

export const firebaseApp = initializeApp({
  apiKey: "AIzaSyCn5S3_UFq_LTI4AX77ZwV1Cf85amfgs9M",
  authDomain: "wowpress-cs.firebaseapp.com",
  databaseURL: "https://wowpress-cs-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "wowpress-cs",
  storageBucket: "wowpress-cs.firebasestorage.app",
  messagingSenderId: "1040281362681",
  appId: "1:1040281362681:web:22257913dd883ad79c8228",
})

export const analytics = initializeAnalytics(firebaseApp)
export const db = getFirestore(firebaseApp)
